<template>
	<div class="wrap">
		<!--    header-->
		<gw-header page="/trailerList" ref="gwheader"></gw-header>
		<div class="content-width">
			<div class="big-title" style="margin: 2rem 0;">
				<h3>按品牌检索视频</h3>
			</div>
		</div>
		<div class="width-100" style="border-top: 1px solid #CCCCCC; margin: 2rem 0 4rem;">
			<div class="content-width">
				<ul class="video-class">
					<li v-for="(item, index) in videoClassList" :key="index" :class="item.id === idx ? 'selected-li' : ''" @click="selectedClass(item.id)">
						<span v-html="item.name"></span>
						<span>{{item.num || '0'}}</span>
					</li>
				</ul>
			</div>
		</div>
		<div class="content-width" style="margin: 2rem 0;">
			<el-row :gutter="20" v-if="dataList.length > 0">
				<el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8" v-for="(item, index) in dataList" :key="index">
					<div class="margin-bottom-2rem manager-content">
						<div class="img-box" style="margin-bottom: 1rem;">
							<!-- <gwVideo :videoSrc="item.video_palyurl" :imgSrc="item.video_cover"></gwVideo> -->
              <div class="video-wrap">
                <div :class="currentVideoIndex === index && isVideoPlay ? 'play-icon stop-icon' : 'play-icon'" @click="playOrStopVideo(index)"></div>
                <img class="fm-image" :src="item.video_cover" @click="playOrStopVideo(index)" />  
              </div>
						</div>
						<p v-html="item.video_title"></p>
					</div>
				</el-col>
				
			</el-row>
			<el-empty v-else description="该类目下暂无视频!"></el-empty>
		</div>
		<!--    footer-->
		<gw-footer></gw-footer>
    <div class="video-dialog" v-if="showVideoDialog">
      <div class="close-box" @click="closeVideoDialog()"></div>
      <video :src="dataList[currentVideoIndex].video_palyurl" ref="myVideo" :controls="true" preload></video>
    </div>
	</div>
</template>

<script>
	import gwHeader from '../../components/header.vue';
	import gwFooter from '../../components/footer.vue';
	import gwVideo from '../../components/video.vue';
	import { chgryVideos, chgryCategory } from '../../api.js';
	export default {
		name: 'trailerList',
		components: {
			gwHeader,
			gwVideo,
			gwFooter
		},
		data() {
			return {
				videoClassList: [], //视频分类
				idx: 1,
				dataList: [
					
				],
        currentVideoIndex: 0,
        isVideoPlay: false,
        showVideoDialog: false,
			}
		},
		created() {
			this.getVideoClass();
			this.getDataList();
		},
		methods: {
			// 获取视频分类列表
			async getVideoClass(){
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				const { data } = await chgryCategory('get', {});
				if(data && data.length != 0){
					this.videoClassList = data;
				}else{
					this.videoClassList = [];
				}
				loading.close();
			},
			// 获取宣传片列表
			async getDataList(){
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				const { data } = await chgryCategory('post', this.idx);
				if(data && data.length != 0){
					this.dataList = data || [];
				}else{
					this.dataList = [];
				}
				loading.close();
			},
			// 选中分类
			selectedClass(id){
				this.idx = id;
				this.getDataList();
			},
      // 播放或暂停视频
      playOrStopVideo(index){
        if(index === this.currentVideoIndex){
          this.isVideoPlay = !this.isVideoPlay;
        }else{
          this.isVideoPlay = true;
        }
        this.showVideoDialog = true;
        this.currentVideoIndex = index;
        this.$nextTick(() => {
          if(this.isVideoPlay){
            this.$refs.myVideo.play();
          }else{
            this.$refs.myVideo.pause();
          }
        })
        // 绑定视频播放与暂停事件监听，同步播放或暂停的状态
        this.$nextTick(() => {
          this.$refs.myVideo.addEventListener("play", () => {
          	this.isVideoPlay = true;
          });
          // 监听视频暂停
          this.$refs.myVideo.addEventListener("pause", () => {
          	this.isVideoPlay = false;
          });
        })
      },
      closeVideoDialog(){
        this.showVideoDialog = false;
        this.$refs.myVideo.pause();
      },
		},
		mounted() {

		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .video-dialog{
    position: fixed;
    left: 50%;
    top: 50%;
    width: 46.875vw;
    height: 31.25vw;
    margin-left: -23.438vw;
    margin-top: -15.625vw;
    z-index: 99999;
    .close-box{
      position: absolute;
      right: 0;
      top: 0;
      width: 4.167vw;
      height: 4.167vw;
      background: url(data:image/png;base64,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) no-repeat 50%;
      background-size: 4.167vw 4.167vw;
      z-index: 100000;
      cursor: pointer;
    }
    video{
      width: 100%;
      height: auto;
    }
  }
  .video-wrap{
  	width: 100%;
  	height: 100%;
  	overflow: hidden;
  	position: relative;
  	.play-icon{
  		position: absolute;
      left: 50%;
      top: 50%;
      width: 3vw;
      height: 3vw;
      margin-top: -1.5vw;
      margin-left: -1.5vw;
      z-index: 999;
      background: url(data:image/png;base64,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) no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
  	}
    .stop-icon{
      background: url(data:image/png;base64,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) no-repeat;
      background-size: 100% 100%;
    }
  	.fm-image{
  		width: 100%;
  		height: 100%;
  		// object-fit: cover;
  		cursor: pointer;
  	}
    video{
    	width: 100%;
    	height: 100%;
    	background-color: #000000;
    }
  	
  }
	.video-class{
		width: 100%;
		height: auto;
		overflow: hidden;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		li{
			width: 20rem;
			height: 6rem;
			line-height: 6rem;
			text-align: center;
			cursor: pointer;
			border-top: 3px solid transparent;
			span:first-of-type{
				font-size: 1.8rem;
				color: #D9D9D9;
			}
			span:last-of-type{
				font-size: 1rem;
				color: #D9D9D9;
				display: inline-block;
				transform: translateY(-1.5rem);
				margin-left: 0.5rem;
				font-weight: bold;
			}
		}
		li:hover{
			border-top: 3px solid #D11E2B;
			span:first-of-type{
				color: #333333;
			}
			span:last-of-type{
				color: #333333;
			}
		}
		.selected-li{
			border-top: 3px solid #D11E2B;
			span:first-of-type{
				color: #333333;
			}
			span:last-of-type{
				color: #333333;
				
			}
		}
	}
	.big-title{
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		h3{
			font-size: 2.6rem;
			color: #333333;
			margin: 0;
			display: inline-block;
		}
		span{
			font-size: 1.6rem;
			color: #666666;
			padding: 10px 20px;
			background-color: #F7F7F7;
			border-radius: 3rem;
			cursor: pointer;
		}
	}
	.content-text {
		box-sizing: border-box;
		// padding-left: 5rem;
		h1{
			font-size: 4rem;
			color: #333;
			line-height: 6rem;
		}
		h2 {
			font-size: 4rem;
			color: #333;
		}

		h3 {
			font-size: 2.3rem;
			color: #333;
			line-height: 3.5rem;
			margin: 0;
		}

		p {
			font-size: 1.6rem;
			color: #666;
			line-height: 2.5rem;
			span{
				font-size: 2.5rem;
				color: #333333;
				line-height: 4rem;
			}
		}
		.right-icon{
			width: 4rem;
			margin-top: 1rem;
		}
	}
	// .manager-content{
	// 	width: 100%;
	// 	height: 35rem;
	// 	overflow: hidden;
	// 	h3{
	// 		font-size: 2.6rem;
	// 		color: #333333;
	// 		line-height: 5rem;
	// 		overflow: hidden; //超出的文本隐藏
	// 		text-overflow: ellipsis; //溢出用省略号显示
	// 		display: -webkit-box;
	// 		-webkit-line-clamp: 1; // 超出多少行
	// 		-webkit-box-orient: vertical;
	// 	}
	// 	p{
	// 		font-size: 1.5rem;
	// 		color: #333333;
	// 		margin: 0;
	// 		line-height: 2.5rem;
	// 	}
	// 	.right-icon{
	// 		width: 4rem;
	// 		margin-top: 1rem;
	// 	}
	.manager-content{
		height: 30rem;
		.img-box{
			height: 26rem;
		}
		p{
			font-size: 1.6rem;
			color: #333333;
			margin: 0;
			line-height: 4rem;
			overflow: hidden; //超出的文本隐藏
			text-overflow: ellipsis; //溢出用省略号显示
			display: -webkit-box;
			-webkit-line-clamp: 1; // 超出多少行
			-webkit-box-orient: vertical;
		}
		.right-icon{
			width: 4rem;
			margin-top: 1rem;
		}
	}
	

	//  xs  小屏手机设备
	@media only screen and (max-width: 767px) {
		.block-flex {
			display: block;
		}
		.video-bigItem{
			height: 29rem;
			width: 100%;
			.img-box{
				height: 25rem;
			}
		}
		.video-item{
			width: 100%;
			height: 17.33rem;
			.img-box{
				height: 13.33rem;
			}
		}
		.manager-content{
			height: 17.33rem;
			.img-box{
				height: 13.33rem;
			}
		}
	}

	//  sm  手机设备
	@media only screen and (min-width: 768px) {
		.block-flex {
			display: block;
		}
		.video-bigItem{
			height: 29rem;
			width: 100%;
			.img-box{
				height: 25rem;
			}
		}
		.video-item{
			width: 100%;
			height: 17.33rem;
			.img-box{
				height: 13.33rem;
			}
		}
		.manager-content{
			height: 22.33rem;
			.img-box{
				height: 18.33rem;
			}
		}
	}

	// md  平板设备
	@media only screen and (min-width: 992px) {
		.block-flex {
			display: flex;
		}
		.video-bigItem{
			height: 64rem;
			width: 100%;
			.img-box{
				height: 60rem;
			}
		}
		.video-item{
			width: 100%;
			height: 21.33rem;
			.img-box{
				height: 17.33rem;
			}
		}
		.manager-content{
			height: 30rem;
			.img-box{
				height: 26rem;
			}
		}
	}

	// lg  一般电脑设备
	@media only screen and (min-width: 1200px) {
		.block-flex {
			display: flex;
		}
		.video-bigItem{
			height: 64rem;
			width: 100%;
			.img-box{
				height: 60rem;
			}
		}
		.video-item{
			width: 100%;
			height: 21.33rem;
			.img-box{
				height: 17.33rem;
			}
		}
		.manager-content{
			height: 30rem;
			.img-box{
				height: 26rem;
			}
		}
	}

	// xl  屏幕较大设备
	@media only screen and (min-width: 1920px) {
		.block-flex {
			display: flex;
		}
		.video-bigItem{
			height: 64rem;
			width: 100%;
			.img-box{
				height: 60rem;
			}
		}
		.video-item{
			width: 100%;
			height: 21.33rem;
			.img-box{
				height: 17.33rem;
			}
		}
		.manager-content{
			height: 33rem;
			.img-box{
				height: 29rem;
			}
		}
	}
</style>
